// @flow
import { put, call, takeLatest } from "redux-saga/effects";
import {
  GET_HAZARD_SETTINGS_SUCCESS,
  GET_HAZARD_SETTINGS_ERROR,
  GET_HAZARD_SETTINGS,
} from "../../constants";
import axios from "../../../../services/api";

function* getHazardSettings(data) {
  const params = new URLSearchParams();

  try {
    const response = yield call(axios.get, `/settings/`, {
      params,
    });
    if (response.data.error) {
      yield put({
        type: GET_HAZARD_SETTINGS_ERROR,
        data: response.error,
      });
    } else {
      yield put({
        type: GET_HAZARD_SETTINGS_SUCCESS,
        data: response.data,
      });
    }
  } catch (error) {
    yield put({
      type: GET_HAZARD_SETTINGS_ERROR,
      data: error,
    });
  }
}

export default function* getHazardSettingsSaga() {
  yield takeLatest(GET_HAZARD_SETTINGS, getHazardSettings);
}
